import { createTheme } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

const rawTheme = createTheme({
  palette: {
    primary: {
      light: '#fff',
      main: '#e9dce3',
      dark: '#914e72',
    },
  },
  typography: {
    fontFamily: "'apercu-light', sans-serif",
    fontSize: 14,
    fontWeightLight: 300, // Work Sans
    fontWeightRegular: 400, // Work Sans
    fontWeightMedium: 700, // Roboto Condensed
  },
});

const fontHeader = {
  color: rawTheme.palette.text.primary,
  fontWeight: rawTheme.typography.fontWeightMedium,
  fontFamily: "'apercu-light', sans-serif",
  textTransform: 'uppercase',
};

const fontTitle = {
  color: rawTheme.palette.text.primary,
  fontWeight: rawTheme.typography.fontWeightMedium,
  fontFamily: "'dahlia-bold', sans-serif",
};

const theme = {
  ...rawTheme,
  palette: {
    ...rawTheme.palette,
    background: {
      ...rawTheme.palette.background,
      default: rawTheme.palette.common.white,
      placeholder: grey[200],
    },
  },
  typography: {
    ...rawTheme.typography,
    fontHeader,
    h1White: {
      ...rawTheme.typography.h1White,
      ...fontTitle,
      letterSpacing: 0,
      fontSize: 80,
    },
    h1Pink: {
      ...rawTheme.typography.h1Pink,
      ...fontTitle,
      letterSpacing: 0,
      fontSize: 80,
    },
    h2: {
      ...rawTheme.typography.h2,
      ...fontTitle,
      fontSize: 24,
    },
    h3: {
      ...rawTheme.typography.h3,
      ...fontHeader,
      fontSize: 42,
    },
    h4: {
      ...rawTheme.typography.h4,
      ...fontHeader,
      fontSize: 36,
    },
    h5: {
      ...rawTheme.typography.h5,
      fontSize: 20,
      fontWeight: rawTheme.typography.fontWeightLight,
    },
    h6: {
      ...rawTheme.typography.h6,
      ...fontHeader,
      fontSize: 18,
    },
    subtitle1: {
      ...rawTheme.typography.subtitle1,
      fontSize: 18,
    },
    body1: {
      ...rawTheme.typography.body2,
      fontWeight: rawTheme.typography.fontWeightRegular,
      fontSize: 16,
    },
    body2: {
      ...rawTheme.typography.body1,
      fontSize: 14,
    },
  },
};

export default theme;
